import React from 'react';

import { flagStyles } from '../settings';

const SvgNG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3888px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNG;
